import md5 from 'js-md5'

export default () => {
  const ts = parseInt(new Date().getTime() / 1000)

  return {
    time: ts,
    sign: md5(`6A44EA76-B54B-4667-AB10-A96E0266F11D${ts}`)
  }
}



// WEBPACK FOOTER //
// ./src/utils/PMFHeaderUtil.js